import { boxShadow, color } from '@upstox/upstox-ui';

export const container: CSSFunction = ({ theme }) => ({
  width: '240px',
  position: 'absolute',
  backgroundColor: color(theme, theme.colors.ui7),
  right: '0px',
  top: '0px',
  height: '100%',
  boxShadow: boxShadow(theme, [-2, 0, 8, -4, 'ui4'] as BoxShadow),
  cursor: 'default',
  zIndex: 8,
  fontFamily: theme.fonts.tvFont,
});

export const settingsHeader: CSSFunction = ({ theme }) => ({
  padding: '18.5px 16px',
  width: '100%',
  borderBottom: `1px solid ${color(theme, theme.colors.ui3)}`,
});

export const iconContainer: CSSFunction = () => ({
  position: 'absolute',
  right: '18px',
  height: '21px',
  width: '21px',
});

export const closeIcon: CSSFunction = ({ theme }) => ({
  cursor: 'pointer',
  color: color(theme, 'text.1'),
});

export const viewText: CSSFunction = ({ theme }) => ({
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '19px',
  color: color(theme, 'text.1'),
});

export const blockHeading: CSSFunction = ({ theme }) => ({
    fontWeight: 700,
    fontSize: '12px',
    color: color(theme, 'text.2'),
    marginLeft: '8px',
});

export const checkboxContainer: CSSFunction = ({ theme }) => ({
  padding: '5px',
  '& .checkboxIcon': {
    height: '18px !important',
    width: '18px !important',
  },
  '& svg': {
    color: `${color(theme, 'interactive.primary.default')} !important`,
  },
});

export const checkboxLabel: CSSFunction = ({ theme }) => ({
    fontWeight: 400,
    fontSize: '12px',
    marginLeft: '9px',
    color: color(theme, 'text.1'),
});
